import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/utils/config/config.service';
import { SesionService } from 'src/app/utils/sesion/sesion.service';

@Injectable({
  providedIn: 'root'
})
export class ClienteService {

  controller: string = "cliente/";

  constructor(
    private http: HttpClient,
    private config: ConfigService,
    private sesion: SesionService
  ) { }

  insert(cliente: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + 'crear', cliente, this.sesion.headers);
  }

  update(cliente: any): Observable<any> {
    return this.http.put(this.config.apiUrl + this.controller + 'actualizar/' + cliente.id, cliente, this.sesion.headers);
  }

  index_select(): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + 'ver-select', this.sesion.headers);
  }

  deactivate(id: any): Observable<any> {
    return this.http.delete(this.config.apiUrl + this.controller + 'desactivar/' + id, this.sesion.headers);
  }

  activate(id: any): Observable<any> {
    return this.http.delete(this.config.apiUrl + this.controller + "activar/" + id, this.sesion.headers);
  }

  delete(id: any): Observable<any> {
    return this.http.delete(this.config.apiUrl + this.controller + "eliminar/" + id, this.sesion.headers);
  }

  enviarEnlaces(id: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + "enviar-enlaces/" + id, {}, this.sesion.headers);
  }
}
